import React,{Fragment,useState,useEffect,useRef,forwardRef} from "react";
import { connect } from 'react-redux';
import * as LA_DOWNTOWN_DELIVERY_REGION from '../../utils/googleMapRegions';
import * as GIFT_DELIVERY_REGIONS from '../../utils/giftDeliveryRegions';
import * as GoogleAPI from '../../utils/googleApiHelper';

import * as Cart from '../../utils/cartHelper';
import Swal from 'sweetalert2';
import * as LocalStorage from "../../utils/localStorageHelper";
import * as UserActions from '../../actions/userActions';

const DEFAULT_LOCATION = {
    lat: -34.397,
    lng: 150.644
}
const DEFAULT_MAP_ZOOM = 14;

const laDownTownDNDPolygon = new google.maps.Polygon({
    paths: [
        LA_DOWNTOWN_DELIVERY_REGION.REGION_NO_DELIVERY1,
        LA_DOWNTOWN_DELIVERY_REGION.REGION_NO_DELIVERY2
    ],
    strokeColor: '#db3636',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#db3636',
    fillOpacity: 0
});

const laDownTownBikePolygon = new google.maps.Polygon({
    paths: LA_DOWNTOWN_DELIVERY_REGION.REGION_BIKE_DELIVERY,
    strokeColor: '#62af44',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#62af44',
    fillOpacity: 0
});

const laDownTownCarPolygon = new google.maps.Polygon({
    paths: LA_DOWNTOWN_DELIVERY_REGION.REGION_CAR_DELIVERY,
    strokeColor: '#7C3592',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#7c3592',
    fillOpacity: 0
});

const giftDeliverySameDayPolygon = new google.maps.Polygon({
    paths: GIFT_DELIVERY_REGIONS.GIFT_SAME_DAY_DELIVERY,
    strokeColor: '#62af44',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#62af44',
    fillOpacity: 0
});

const giftDeliveryDaysNoticePolygon = new google.maps.Polygon({
    paths: [GIFT_DELIVERY_REGIONS.GIFT_DAYS_NOTICE_DELIVERY_1, GIFT_DELIVERY_REGIONS.GIFT_DAYS_NOTICE_DELIVERY_2],
    strokeColor: '#c6a4cf',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#c6a4cf',
    fillOpacity: 0
});

const laSilverlakeCarPolygon = new google.maps.Polygon({
    paths: LA_DOWNTOWN_DELIVERY_REGION.SILVERLAKE_CAR_DELIVERY,
    strokeColor: '#3c1dc4',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#3c1dc4',
    fillOpacity: 0
});

export const validateLatLngLADownTown = (latLng) => {
    const isInLADownTownDNDPolygon = google.maps.geometry.poly.containsLocation(latLng, laDownTownDNDPolygon);
    const isInLADownTownBikePolygon = google.maps.geometry.poly.containsLocation(latLng, laDownTownBikePolygon);
    const isInLADownTownCarPolygon = google.maps.geometry.poly.containsLocation(latLng, laDownTownCarPolygon);

    if((isInLADownTownBikePolygon || isInLADownTownCarPolygon) && (!isInLADownTownDNDPolygon)) {
        return {
            region:'LA_DOWNTOWN',
            status: true,
            time: 0
        };
    } 
    return {
        region:'LA_DOWNTOWN',
        status: false,
        time: 0
    };
};

export const validateLatLngSilverlake = (latLng) => {
    const isInSilverlakeCarPolygon = google.maps.geometry.poly.containsLocation(latLng, laSilverlakeCarPolygon);
    if(isInSilverlakeCarPolygon) {
        return {
            region:'LA_SILVERLAKE',
            status: true,
            time: 0
        };
    } 
    return {
        region:'LA_SILVERLAKE',
        status: false,
        time: 0
    };
};

/**
 * This is being used for both gift deliveries
 * & normal deliveries in extended areas
 * originally it was intended for gift deliveries only
 * UGLY HACK due to the following requirements:
 *  - For non gift deliveries - Remove 1 day delivery,
        Both Delivery zones will be 2 day deliveries.
        SilverLake region now added for instant delivery
 */
export const validateLatLngLAGift = (latLng) => {
    const LADownTownDeliveryValidationStatus = validateLatLngLADownTown(latLng);
    const LASilverlakeDeliveryValidationStatus = validateLatLngSilverlake(latLng);
    if(LASilverlakeDeliveryValidationStatus.status) {
        return  {
            region:'LA_SILVERLAKE',
            status: true,
            time: 2,
            timeDisplay: '2 hours',
        }
    }
    if(LADownTownDeliveryValidationStatus.status) {
        return  {
            region:'LA_DOWNTOWN',
            status: true,
            time: 2,
            timeDisplay: '2 hours',
        }
    }
    const isInGiftDeliverySameDayPolygon = google.maps.geometry.poly.containsLocation(latLng, giftDeliverySameDayPolygon);
    const isInGiftDeliveryDaysNoticePolygon = google.maps.geometry.poly.containsLocation(latLng, giftDeliveryDaysNoticePolygon);
    if(isInGiftDeliverySameDayPolygon) {
        return  {
            region:'LA_GIFT_SAME_DAY',
            status: true,
            time: 24,
            timeDisplay: '1 day'
        };
    }

    if(isInGiftDeliveryDaysNoticePolygon) {
        return  {
            region:'LA_GIFT_DAYS_NOTICE',
            status: true,
            time: 48,
            timeDisplay: '2 days'
        };
    }

    return {
        region: 'SHIPPO',
        status: true,
        time: 0,
    }
}


const GoogleAddressDiv=({sendDataToParent})=>{
  let placeChangeListener = null;
  const autocompleteElement = useRef();
  const mapElement = useRef();
  const [place, setPlace] = useState("");
  const [area, setArea] = useState("");
  const [DeliveryValidationStatusObj, setDeliveryValidationStatusObj] = useState({});
  let autoComplete = null;
  
  let map = null;
  let marker = null;
  useEffect(() => {
    initMap();
  
  }, []);
  //from placepicker
  const initMap=()=> {
    let location = {
      lat: 34.0502,
      lng: -118.257
    }
    map = GoogleAPI.initMap(mapElement.current, {}, onPlaceChanged);
    marker = GoogleAPI.addMarker(map, location);
    GoogleAPI.addMarkerDragEvent(marker, onPlaceChanged);
    GoogleAPI.addMapClickEvent(map, onPlaceChanged);
    GoogleAPI.setAutocompleteService(autocompleteElement.current, onPlaceChanged);
  }
  const onPlaceChanged=(place)=> {
    if(place.name) {
      let placeName = place.name.trim();
      let placeNameExistence = place.formatted_address.indexOf(placeName);
  
      if (placeNameExistence !=0)
        place.formatted_address = place.name + ', ' + place.formatted_address;
    }
    
    let location = GoogleAPI.getLocationByPlace(place);
    GoogleAPI.updateMarker(map, marker, location);
    let deliveryArea;
    if (place && place.geometry) {
       deliveryArea = GoogleAPI.checkAreaDeliverable(place.geometry.location);
      console.log("checkAreaDeliverable deliveryArea xxxxx",deliveryArea);
      setArea(deliveryArea);
      validateDeliveryArea(deliveryArea);
    }
    const deliveryValidationStatus = validateLatLongForDelivery(location, 'GIFT');
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS, {delivery_validation_status: deliveryValidationStatus});
    // this.setState({place, deliveryValidationStatus: {
    //     ...deliveryValidationStatus,
    //     time: deliveryValidationStatus.time > 12 ? deliveryValidationStatus.time: 0,
    //     // only used for normal deliveries in extended areas
    //     // intentionally changed to 2 business days
    //     // read JSDoc - validateLatLongForDelivery
    //     timeDisplay: deliveryValidationStatus.time < 12 ? '' : '2 days'
    //   }});
      setDeliveryValidationStatusObj({
        ...deliveryValidationStatus,
        time: deliveryValidationStatus.time > 12 ? deliveryValidationStatus.time: 0,
        // only used for normal deliveries in extended areas
        // intentionally changed to 2 business days
        // read JSDoc - validateLatLongForDelivery
        timeDisplay: deliveryValidationStatus.time < 12 ? '' : '2 days'
      });
      sendDataToParent({place,area:deliveryArea});
    autocompleteElement.current.value = place.formatted_address;
  }
  const validateDeliveryArea=(area)=> {
    let isDeliveryPermitted = (area !== 'restricted');
    
    
console.log("isDeliveryPermitted xxxx",isDeliveryPermitted);
    if(!isDeliveryPermitted) {
      
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Sorry, We dont deliver here, please choose different location from map or you can search location',
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }
  
  
  

  return <div><label>Add Address:</label><input autocomplete="one-time-code" placeholder="Enter address..." className="form-control" ref={autocompleteElement}  /><div className={`col-md-12 invisible`}>
  <div className="address-map" ref={mapElement}></div>
</div></div>;
}
const ChooseAddressBarUI = ({focusHandler, userAddresses,showAlert,googleAddress,props}) => { 
  const [showForm, setShowForm] = useState(false);
  const [place, setPlace] = useState('');
  const [area, setArea] = useState('');
  const [selectedAddressId, setSelectedAddreessId] = useState('');
  const [apartment, setApartment] = useState(null);
  // const dispatch = useDispatch();
console.log("root showAlert",showAlert);
  // useEffect(() => {
  //   console.log("root xxx");
  //   // document.querySelector("#addAddressDiv")
  //   function handlekeydownEvent(event) {
  //   console.log();
  //   }
  //   let root = document.querySelector('#addAddressDiv');
  //   console.log("root",root);
  //   if (root) {
        
  //   root.addEventListener('click', () => alert("Hi user 2!"))
  //   }
  
  // }, [showAlert==true]);
  const onSelectUserAddress=(address)=>{
    const deliveryValidationStatus = validateLatLongForDelivery({
      lat: address.loc[1],
      lng: address.loc[0],
    }, 'GIFT');
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS, {delivery_validation_status: deliveryValidationStatus});
    setSelectedAddreessId(address._id)
    LocalStorage.put('delivery_address', {loc:address.description,id:address._id});
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS, { address: address });
    
  }
  const addNewAddress=()=>{

    console.log("address",place);
    addAddress();
  }
 
  const sendDataToParent = (index) => { // the callback. Use a better name
    console.log("sendDataToParent",index);
    setPlace(index.place);
    setArea(index.area);
    // setDrive(index);
  };

  const addAddress=()=> {
    if(place.name) {
      let placeName = place.name.trim();
      let placeNameExistence = place.formatted_address.indexOf(placeName);
  
      if (placeNameExistence !=0)
        place.formatted_address = place.name + ', ' + place.formatted_address;
    }
    console.log("xxxxxx place",place);
    // const {place, actionMode, ,apartment, area} = this.state;
    let latLng = GoogleAPI.getLocationByPlace(place);
    if (!place) {
      alert("Please select delivery address");
    }else {
      const country = GoogleAPI.extractFromAddress(place.address_components, 'country', 'short_name');
      const houseNumber = GoogleAPI.extractFromAddress(place.address_components,"street_number");
      const streetRoute = GoogleAPI.extractFromAddress(place.address_components,"route");
      let street = houseNumber && streetRoute ? `${houseNumber} ${streetRoute}` : null;
      street = street ? street : streetRoute;
      const city = GoogleAPI.extractFromAddress(place.address_components, 'locality');
      const state = GoogleAPI.extractFromAddress(place.address_components, 'administrative_area_level_1', 'short_name');
      const zip = GoogleAPI.extractFromAddress(place.address_components, 'postal_code');
      if (country !== 'US' && country !== 'United States') {
         
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Sorry, We dont deliver outside of the United States, please choose different location from map or you can search location',
          timer: 2000,
          timerProgressBar: true,
        });
        return;
      }
      console.log("xxx send add userAddrees",props);
      // add address
      if(props.user){
      props.dispatch(UserActions.addUserAddress({
        description: place.formatted_address,
        loc: [latLng.lng, latLng.lat],
        nearestStore: area,
        street,
        city,
        state,
        zip,
        country,
        apartment
      }, response => {
        console.log("ADD_ADDRESS_RESPONSE", response);
        if(response.status) {

          LocalStorage.put('delivery_address', {loc:place.formatted_address,id:response.data[response.data.length-1]._id});
          let addresses = response.data;
          Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS, {address: addresses[addresses.length-1]});
          Swal.fire({
            icon: 'success',
            title: 'Address saved successfully',
            showConfirmButton: false,
            timer: 5500
          })
    props.dispatch(UserActions.getProfileDetails(response => {
      const {data,status}=response;
      if (status) {
        let user = data;
        // this.setState({
        //   firstName: user && user.name
        //     ? user.name.first
        //     : '',
        //   lastName: user && user.name
        //     ? user.name.last
        //     : '',
        //   email: user && user.email
        //     ? user.email
        //     : '',
        //   dob: user && user.dob
        //     ? user.dob
        //     : '',
        //   phone: user && user.phone
        //     ? user.phone
        //     : '',
        //   addresses: user
        //     ? user.addresses
        //     : [],
        //     dialCode: user && user.dialCode
        //     ? user.dialCode
        //     : '1',
        //     iso: user && user.iso
        //     ? user.iso
        //     : 'us',
        // })
        // if('isEmailVerified' in data && data.isEmailVerified == true ){

        //   this.setState({isEmailVerified:data.isEmailVerified});
        // }
        // if('isPhoneVerified' in data && data.isPhoneVerified == true ){
          
        //   this.setState({ isPhoneVerified: true });
          
        // }
      } else {
        console.log("failed to load user details")
        // this.setState({
        //   showAlert: true,customClass:"with-close",
        //   swalParams: {
        //     title: 'Failed to load profile details, please try again later!',
        //     type: "error",
        //     showConfirmButton: false
        //   }
        // })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: response.data && response.data.message || "Something went wrong adding the address. Please try later.",
            timer: 10000,
            timerProgressBar: true,
          });
        }
      }));
      }else{

      Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS, {address: {
        "description": place.formatted_address,
        "street": street,
        "city": city,
        "state": state,
        "country": country,
        "zip": 60406,
        "loc": [latLng.lng, latLng.lat],
        "apartment": apartment,
        "nearestStore": area,
        "shippoAddressId": 1,
        "_id": 1
    }});

            LocalStorage.put('delivery_address', {loc:place.formatted_address,id:1});
            Swal.fire({
              icon: 'success',
              title: 'Address saved successfully',
              showConfirmButton: false,
              timer: 5500
            });
      }
      

    }
  }
  const renderForm=()=> {
    return (
        <div> 
          
          {place.formatted_address?<div><label>Apartment:</label>
<input
    className="form-control"
    type="text"
    value={apartment}
    onChange={e => setApartment(e.target.value)}
/></div>:null}
                
                <GoogleAddressDiv sendDataToParent={sendDataToParent}/>

                
               <button onClick={()=>addNewAddress()}>Save</button> 
                <button onClick={()=>setShowForm(false)}>Cancel</button> 
           
       </div>
    );
 }


 
return(<div className="info-row add-address-row">
{showForm?renderForm():<div ><div className="content-left pb-3" onClick={() => setShowForm(true)}><i className="fa fa-plus-circle" />Add New Address</div>
<div>{userAddresses?userAddresses.map(address => {
  let isSelectedAddress = selectedAddressId==address._id ? true : false;
  let isLocalStorageHasDelivery = LocalStorage.get("delivery_address")!==null&&LocalStorage.get("delivery_address").id == address._id ? true : false;
  return(
                            <p className={`user-address-card ${(isSelectedAddress||isLocalStorageHasDelivery)?"active":""} `} key={address._id} onClick={() =>onSelectUserAddress(address)}>{address.apartment ? `Apartment #: ${address.apartment}, ${address.description}` : address.description}</p>)}):null
                            }</div></div>}

                             
</div>)
};
export const validateLatLongForDelivery = (latLng, deliveryValidation) => {
  let deliveryValidationStatus = {
      region:'NA',
      status: true,
      time: 0
  }; // return this default value if there is no deliveryValidation needed.
  const latLngObj = new google.maps.LatLng(latLng)
  if (deliveryValidation === 'NORMAL') {
      deliveryValidationStatus =  validateLatLngLADownTown(latLngObj);
  } else if(deliveryValidation === 'GIFT') {
      deliveryValidationStatus = validateLatLngLAGift(latLngObj);
  } 
  return deliveryValidationStatus;
};
export default ChooseAddressBarUI;



// WEBPACK FOOTER //
// ./src/containers/commons/ChooseAddressBarUI.js